<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content">

      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Manage Customer Portal Link</p>
          <button
            class="delete"
            aria-label="close"
            @click="close()">
          </button>
        </header>

        <div class="modal-card-body">

          <template v-if="parseDate(rfq.token_expiration_date) > new Date()">
            <label class="label">Customer Portal Link</label>
            <div class="field">

              <v-text-field
                class="field has-addons"
                :value="previewLink"
                :is-expanded="true"
                :readonly="true"
                :has-addons="true">
                <div class="control">
                  <a 
                    class="button is-link" 
                    @click.stop=""
                    :href="previewLink"
                    target="_blank">
                    <span class="icon is-medium">
                      <i class="fas fa-eye"></i>
                    </span>
                  </a>
                </div>
                <div class="control">
                  <button 
                    class="button is-primary" 
                    @click.stop="helpers.copyToClipboard(previewLink)">
                    <span class="icon is-medium">
                      <i class="fas fa-copy"></i>
                    </span>
                  </button>
                </div>
              </v-text-field>

            </div>  

            <div class="mb-5">
              This link expires 
              <strong>{{ formatDistance(parseDate(rfq.token_expiration_date)) }}</strong>
            </div>
          </template>

          <div v-else class="mb-3">
            There is no active link for this proposal.
            <span v-if="rfq.token_expiration_date">
              The latest link expired 
              {{ formatDistance(parseDate(rfq.token_expiration_date)) }}.
            </span>
          </div>

          <v-fade-transition mode="out-in">
            <div v-if="regenerating">
              <hr>
              <label class="label">Days Till Link Expires</label>
              <v-text-field
                required
                type="number"
                class="field has-addons"
                v-model="tokenExpiryDays"
                :is-expanded="true"
                :has-addons="true">
                <div class="control">
                  <button 
                    class="button is-primary" 
                    :disabled="isRegenerating"
                    :class="{ 'is-loading': isRegenerating }"
                    @click.stop="regenerate()">
                    <span class="icon is-medium">
                      <i class="fas fa-check"></i>
                    </span>
                  </button>
                </div>
                <div class="control">
                  <button 
                    class="button" 
                    @click.stop="regenerating = false">
                    <span class="icon is-medium">
                      <i class="fas fa-times"></i>
                    </span>
                  </button>
                </div>
              </v-text-field>
            </div>

            <div class="buttons" v-else>
              <button 
                class="button is-primary" 
                @click.stop="regenerating = true">
                <span class="icon is-medium">
                  <i class="fas fa-sync"></i>
                </span>
                <span>Regenerate Link</span>
              </button>

              <v-fade-transition mode="out-in">
                <button
                  v-if="parseDate(rfq.token_expiration_date) > new Date()"
                  :disabled="blacklisting"
                  class="button" 
                  :class="{ 'is-loading': blacklisting }"
                  @click.stop="blacklist()">
                  <span class="icon is-medium">
                    <i class="fas fa-unlink"></i>
                  </span>
                  <span>Disable Link</span>
                </button>
              </v-fade-transition>
              
            </div>
          </v-fade-transition>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import VTextField from '@/components/base/VTextField'
import VFadeTransition from '@/components/transitions/VFadeTransition'

import helpers from '@/helpers'
import { formatDistance, parseJSON } from 'date-fns'

import { mapState, mapActions } from 'vuex'

export default {
  components: { VTextField, VFadeTransition },
  props: {
    value: {
      type: Boolean
    }
  },
  data() {
    return {
      regenerating: false,
      helpers: helpers ,
      tokenExpiryDays: 60,
      formatDistance: d => d ? formatDistance(d, new Date(), { addSuffix: true }) : d,
      parseDate: (date) => { return date ? parseJSON(date) : date },
      isRegenerating: false,
      blacklisting: false
    }
  },
  computed: {
    ...mapState("rfq", ["rfq"]),
    ...mapState("proposalMaker", ["proposal"]),
    previewLink({ rfq }) {
      return `${window.location.origin}/customerportal/estimationpreview/${rfq.api_token}`
    }
  },
  methods: {
    ...mapActions("rfq", ["regenerateToken", "blacklistToken"]),
    regenerate() {
      this.isRegenerating = true;
      this.regenerateToken({ 
        rfqId: this.rfq.id,
        data: { days: this.tokenExpiryDays, proposal_id: this.proposal.id }
      }).then(() => {
        this.isRegenerating = false;
        this.regenerating = false;
      }).catch(() => this.isRegenerating = false);
    },
    blacklist() {
      this.blacklisting = true;
      this.blacklistToken(this.rfq.id)
        .then(() => this.blacklisting = false)
        .catch(() => this.blacklisting = false)
    },
    close(clear=false) {
      this.$emit('input', false);
      if (clear) {
        this.clearData();
      }
    },
    clearData() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  }
}
</script>


<style scoped>
.modal-card {
  border-radius: 6px;
}
</style>